import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { ref, onMounted } from "vue";
import {
  HubConnection,
  HubConnectionBuilder,
  LogLevel,
} from "@microsoft/signalr";
import { IHttpConnectionOptions } from "@microsoft/signalr/src/IHttpConnectionOptions";


export default /*#__PURE__*/_defineComponent({
  __name: 'TenantSwitch',
  setup(__props) {

const currentTenant = localStorage.getItem("tenant");
const storageTenantList = localStorage.getItem("tenantList");
const tenantList = ref(<any>[]);

const switchTenant = (tenant: any) => {
  localStorage.setItem("tenant", tenant.tenantId.toString());
  localStorage.setItem("id_token", tenant.token.toString());
  const tenantInfo = {
    access_token: tenant.token,
  };
  localStorage.setItem("jwt_token", JSON.stringify(tenantInfo));
  window.location.reload();
};
// const initializeSignalR = (tenantList: any) => {
//   const token = tenantList[0].token;
//   const url = process.env.VUE_APP_API_URL + "/hub/client";
//   const connection = new HubConnectionBuilder()
//     .withUrl(url, {
//       withCredentials: false,
//       accessTokenFactory: () => token,
//     } as IHttpConnectionOptions)
//     .withAutomaticReconnect()
//     .configureLogging(LogLevel.Warning)
//     .build();
//   connection.start().then(() => {
//     console.log("tenantId", tenantList[0].tenantId, "Switch SignalR Connected");
//   });
// };
onMounted(() => {
  if (storageTenantList) {
    const _tenantList = JSON.parse(storageTenantList);
    tenantList.value = _tenantList.filter(
      (item) => item.tenantId != currentTenant
    );
  }
  // initializeSignalR(tenantList.value);
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tenantList.value, (item, index) => {
    return (_openBlock(), _createBlock(_component_el_button, {
      size: "small",
      key: index,
      onClick: ($event: any) => (switchTenant(item))
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("title.tenants." + item.tenantId)), 1)
      ]),
      _: 2
    }, 1032, ["onClick"]))
  }), 128))
}
}

})